import Base from './base'

export default class MelodyCustomFields extends Base {
  async getCustomFields() {
    try {
      return this.api.get('custom_fields.json')
    } catch (e) {
      return null
    }
  }

  async getCustomFieldsByType(fieldType) {
    try {
      return await this.api.get(`custom_fields?field_type=${fieldType}`)
    } catch (e) {
      return null
    }
  }
}
